// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__11u6n","label":"LabeledBox_label__3PQv1"};